import type {
  createShadowAliasesFn,
  createShadowGlobalsFn,
  createShadowsFn,
} from "./types";

export const shadowGlobals = [
  "xxs",
  "xs",
  "sm",
  "md",
  "lg",
  "xl",
  "xxl",
  "xxxl",
] as const;

export const shadowAliases = [
  "shadowFixedBottom",
  "shadowFixedTop",
  "light",
  "regular",
  "tile",
  "box",

  "banner",
  "bottomSheet",
  "button",
  "buttonHover",
  "card",
  "dialog",
  "drawer",
  "omnisearch",
  "toast",
  "tooltip",
] as const;

export const createShadowGlobals: createShadowGlobalsFn = (colors, _mode) => {
  return {
    xxs: {
      // ios shadow properties
      shadowColor: colors.black,
      shadowOffset: {
        width: 0,
        height: 1,
      },
      shadowOpacity: 0.15,
      shadowRadius: 3,

      // android shadow property
      elevation: 1,
    },
    xs: {
      // ios shadow properties
      shadowColor: colors.black,
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.15,
      shadowRadius: 6,

      // android shadow property
      elevation: 2,
    },
    sm: {
      // ios shadow properties
      shadowColor: colors.black,
      shadowOffset: {
        width: 0,
        height: 4,
      },
      shadowOpacity: 0.15,
      shadowRadius: 8,

      // android shadow property
      elevation: 3,
    },
    md: {
      // ios shadow properties
      shadowColor: colors.black,
      shadowOffset: {
        width: 0,
        height: 6,
      },
      shadowOpacity: 0.15,
      shadowRadius: 10,

      // android shadow property
      elevation: 4,
    },
    lg: {
      // ios shadow properties
      shadowColor: colors.black,
      shadowOffset: {
        width: 0,
        height: 8,
      },
      shadowOpacity: 0.15,
      shadowRadius: 12,

      // android shadow property
      elevation: 5,
    },
    xl: {
      // ios shadow properties
      shadowColor: colors.black,
      shadowOffset: {
        width: 0,
        height: 10,
      },
      shadowOpacity: 0.15,
      shadowRadius: 14,

      // android shadow property
      elevation: 6,
    },
    xxl: {
      // ios shadow properties
      shadowColor: colors.black,
      shadowOffset: {
        width: 0,
        height: 12,
      },
      shadowOpacity: 0.15,
      shadowRadius: 16,

      // android shadow property
      elevation: 7,
    },
    xxxl: {
      // ios shadow properties
      shadowColor: colors.black,
      shadowOffset: {
        width: 0,
        height: 14,
      },
      shadowOpacity: 0.15,
      shadowRadius: 18,

      // android shadow property
      elevation: 8,
    },
  };
};

export const createShadowAliases: createShadowAliasesFn = (
  shadows,
  colors,
  mode,
) => {
  return {
    shadowFixedBottom: {
      // ios shadow properties
      shadowColor: colors.black,
      shadowOffset: {
        width: 0,
        height: -1,
      },
      shadowOpacity: 0.12,
      shadowRadius: 6,

      // android shadow property
      elevation: 3,
    },
    shadowFixedTop: {
      // ios shadow properties
      shadowColor: colors.black,
      shadowOffset: {
        width: 0,
        height: 1,
      },
      shadowOpacity: 0.12,
      shadowRadius: 6,

      // android shadow property
      elevation: 3,
    },
    light: {
      // ios shadow properties
      shadowColor: mode === "light" ? colors.gray800 : colors.black,
      shadowOpacity: mode === "light" ? 0.08 : 0.2,
      shadowOffset: { width: 0, height: 4 },
      shadowRadius: 4,

      // android shadow property
      elevation: 2,
    },
    regular: {
      // ios shadow properties
      shadowColor: mode === "light" ? colors.gray800 : colors.black,
      shadowOpacity: mode === "light" ? 0.2 : 0.3,
      shadowOffset: { width: 0, height: 4 },
      shadowRadius: 8,

      // android shadow property
      elevation: 6,
    },
    tile: {
      shadowColor: mode === "light" ? colors.gray200 : colors.gray950,
      shadowOpacity: 1,
      shadowOffset: { width: 0, height: 4 },
      shadowRadius: 0,

      // android shadow property
      elevation: 6,
    },
    box: {
      // ios shadow properties
      shadowColor: mode === "light" ? colors.gray800 : colors.black,
      shadowOpacity: mode === "light" ? 0.2 : 0.3,
      shadowOffset: { width: 0, height: 4 },
      shadowRadius: 8,

      // android shadow property
      elevation: 6,
    },

    banner: shadows.md,
    bottomSheet: shadows.xxs,
    button: shadows.sm,
    buttonHover: shadows.md,
    card: shadows.xs,
    dialog: shadows.lg,
    drawer: shadows.lg,
    omnisearch: shadows.lg,
    toast: shadows.md,
    tooltip: shadows.md,
  };
};

export const createShadows: createShadowsFn = (colors, mode) => {
  const shadowGlobals = createShadowGlobals(colors, mode);

  return {
    ...shadowGlobals,
    ...createShadowAliases(shadowGlobals, colors, mode),
  };
};
